import React from 'react';

import {Link} from 'react-router';

import {DocumentActionsButton} from 'app/components/general/DocumentActionsButton';
import {
  StyledCompactItemHeaderDiv,
  StyledCompactItemHeaderSpan,
} from 'app/general/bootstrap/utils';
import {ItemRelationsListOfTeams} from 'app/general/dashboards/ItemRelationsListOfTeams';
import {ItemRelationsLists} from 'app/general/dashboards/ItemRelationsLists';
import {DocumentIcon} from 'app/notifly/components/DocumentIconWithNotifications';
import {getObjectName} from 'app/utils/fallbacks';

import type {BadgeRelation} from 'app/general/dashboards/ItemRelationsBadges';
import type {DocumentSerializedType} from 'sweet-types';

type FullProps = {
  object: DocumentSerializedType;
};

const relations: Array<BadgeRelation> = [
  {
    ct: 'team',
    getter: (d: DocumentSerializedType['document']) =>
      d.team_memberships.map((team) => team.team),

    Component: ItemRelationsListOfTeams,
  },
];

export const FullDocItem = ({object}: FullProps) => {
  return (
    <li className="list-group-item list-group-item-action flex-column align-items-start">
      <div
        className="row py-2 d-flex align-items-center"
        style={{
          position: 'relative',
        }}
      >
        <StyledCompactItemHeaderDiv className="flex-column">
          <Link
            to={object.html_url}
            className="text-dark font-weight-bold d-block d-flex w-100"
          >
            <StyledCompactItemHeaderSpan>
              <DocumentIcon
                className="mr-1"
                contentType={object.document_content_type}
              />

              {getObjectName(object, object.document_content_type, true)}
            </StyledCompactItemHeaderSpan>
          </Link>
        </StyledCompactItemHeaderDiv>

        <div className="col-auto order-lg-5">
          <DocumentActionsButton
            document={object}
            pageContext="importing"
            currentFolder={undefined}
            refreshData={() => undefined}
          />
        </div>

        <div className="col-12 order-last">
          <ItemRelationsLists
            object={object.document}
            activeRelations={{tag: false, team: true}}
            relations={relations}
          />
        </div>
      </div>
    </li>
  );
};
